var _path, _polygon, _path2, _g, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXml(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 614.29,
    height: 800,
    viewBox: "0 0 614.29 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.5,0H20.9C9.36,0,0,9.36,0,27.51v758.2c0,4.93,9.36,14.29,20.9,14.29h572.49c11.54,0,20.9-9.36,20.9-14.29V185.4c0-9.94-1.33-13.14-3.67-15.5L444.39,3.67c-2.36-2.34-5.56-3.67-8.89-3.67Z",
    fill: "#e9e9e0"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "442.86 2.16 442.86 171.43 612.13 171.43 442.86 2.16",
    fill: "#d9d7ca"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M593.39,800H20.9c-11.54,0-20.9-9.36-20.9-20.9v-221.96h614.29v221.96c0,11.54-9.36,20.9-20.9,20.9Z",
    fill: "#f29c1f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M183.99,687.21l36.53,69.93h-27.14l-22.86-54.3h-1.96l-24.61,54.3h-27.14l36.53-69.93-38.87-74.03h26.76l25.39,58.6h1.96l27.54-58.6h26.76l-38.87,74.03Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.26,613.2h23.83v143.94h-23.83v-99.03l-32.23,80.07h-20.7l-32.43-80.07v99.03h-23.83v-143.94h23.83l42.77,98.44,42.59-98.44Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.04,613.2v126.17h66.21v17.77h-90.04v-143.94h23.83Z",
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.57,342.86c-3.66,0-7.31-1.4-10.1-4.19-5.59-5.59-5.59-14.61,0-20.2l85.71-85.71c5.59-5.59,14.61-5.59,20.2,0,5.59,5.59,5.59,14.61,0,20.2l-85.71,85.71c-2.79,2.79-6.44,4.19-10.1,4.19Z",
    fill: "#f29c1f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.29,428.57c-3.66,0-7.31-1.4-10.1-4.19l-85.71-85.71c-5.59-5.59-5.59-14.61,0-20.2s14.61-5.59,20.2,0l85.71,85.71c5.59,5.59,5.59,14.61,0,20.2-2.79,2.79-6.44,4.19-10.1,4.19Z",
    fill: "#f29c1f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M385.71,428.57c-3.66,0-7.31-1.4-10.1-4.19-5.59-5.59-5.59-14.61,0-20.2l85.71-85.71c5.59-5.59,14.61-5.59,20.2,0s5.59,14.61,0,20.2l-85.71,85.71c-2.79,2.79-6.44,4.19-10.1,4.19Z",
    fill: "#f29c1f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M471.43,342.86c-3.66,0-7.31-1.4-10.1-4.19l-85.71-85.71c-5.59-5.59-5.59-14.61,0-20.2s14.61-5.59,20.2,0l85.71,85.71c5.59,5.59,5.59,14.61,0,20.2-2.79,2.79-6.44,4.19-10.1,4.19Z",
    fill: "#f29c1f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.14,457.14c-1.57,0-3.19-.27-4.76-.83-7.44-2.63-11.34-10.79-8.71-18.23l85.71-242.86c2.64-7.44,10.76-11.36,18.23-8.71,7.44,2.63,11.34,10.79,8.71,18.23l-85.71,242.86c-2.07,5.89-7.59,9.54-13.47,9.54Z",
    fill: "#f29c1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXml);
export default __webpack_public_path__ + "static/media/XML.c8d2a872b2ed7d30d30e71beb03baab0.svg";
export { ForwardRef as ReactComponent };